import styled, { keyframes } from 'styled-components'
import { useEffect, useContext } from 'react'
import { DialogClose } from '../../pages/Dialog/Dialog'
import circleX from '../../assets/circleX.svg'
import { LanguageContext } from '../../components/LanguageContext'
import { FormContext } from '../../components/FormContext'
import Mail from '../../assets/mail.svg'
import CheckGreen from '../../assets/checkGreen.svg'
import Button from '../Button'

const Contact = ({ dialog, formStatus, setFormStatus }) => {
	const { language } = useContext(LanguageContext)
	const { formInfo, setFormInfo } = useContext(FormContext)
	const sysMessages = {
		english: {
			sending: 'Message sending...',
			sent: 'Message sent!',
			error: 'Error',
		},
		french: {
			sending: 'Message en transit',
			sent: 'Message envoyé!',
			error: 'Erreur',
		},
	}
	const text = {
		english: {
			title: 'Tell me about your project!',
			name: 'Your name',
			email: 'Your email',
			send: 'Send',

			errorMsg1:
				'There was an error sending your message. Please send an email to ',
			errorMsg2: 'Here is your message:',
		},
		french: {
			title: 'Parles-moi de ton projet!',
			name: 'Votre nom',
			email: 'Votre courriel',
			send: 'Envoyer',

			errorMsg1:
				"Une erreur s'est produite pendant l'envoi de votre message. Veuillez envoyer un courriel à ",
			errorMsg2: 'Voici votre message:',
		},
	}
	let errorFlag = false
	const apiCall = async () => {
		return await fetch('https://sabsite.onrender.com/emailForm', {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			method: 'POST',
			body: JSON.stringify({ ...formInfo, lang: language }),
		}).catch((err) => Promise.reject(new Error('error catch')))
	}
	const submitForm = (e) => {
		errorFlag = true
		e.preventDefault()
		setFormStatus('sending')
		console.log(formInfo)
		new Promise((resolve, reject) => {
			setTimeout(() => {
				console.log("time's up")
				if (errorFlag) {
					reject(new Error('Error: did not respond in time'))
				}
			}, 15000)
			apiCall().then(
				(res) => {
					resolve(res)
				},
				(err) => {
					reject(err)
				}
			)
		})
			// .then((res) => {
			//   console.log(res.status);
			//   res.response.json();
			// })
			.then((data) => {
				console.log(data)
				errorFlag = false
				if (data.status === 200) {
					console.log('success')
					setFormStatus('sent')
				}
			})
			.catch((error) => {
				errorFlag = true
				setFormStatus('error')
				console.log(error)
			})
	}

	useEffect(() => {
		if (formStatus === 'sent') {
			setFormInfo({
				name: '',
				email: '',
				message: '',
			})
		}
	}, [formStatus])

	return (
		<Wrapper dialog={dialog ? 'relative' : 'block'}>
			{formStatus === 'standby' && (
				<StyledForm onSubmit={(e) => submitForm(e)}>
					<StyledTitle>{text[language].title}</StyledTitle>
					{dialog && (
						<StyledClose>
							<img alt={'close button'} src={circleX} />
						</StyledClose>
					)}
					<InputWrap>
						{/* <label name="ContactName">{text[language].name}</label> */}
						<StyledInput
							name='ContactName'
							type='text'
							onChange={(e) => {
								setFormInfo({ ...formInfo, name: e.target.value })
							}}
							value={formInfo.name}
							required
							placeholder={text[language].name}
						/>
					</InputWrap>
					<InputWrap>
						{/* <label name="email">{text[language].email}</label> */}
						<StyledInput
							name='email'
							type='email'
							onChange={(e) => {
								setFormInfo({ ...formInfo, email: e.target.value })
							}}
							value={formInfo.email}
							required
							placeholder={text[language].email}
						/>
					</InputWrap>
					<MessageBox
						name='ContactComment'
						type='textarea'
						placeholder='Message...'
						onChange={(e) => {
							setFormInfo({ ...formInfo, message: e.target.value })
						}}
						value={formInfo.message}
						required
					/>
					<Button type='submit' text={text[language].send} />
				</StyledForm>
			)}
			{formStatus !== 'standby' && (
				<PostSend>
					{formStatus === 'sending' && <Envelope src={Mail} />}
					{formStatus === 'sent' && (
						<img alt={'green checkmark'} src={CheckGreen} />
					)}

					<StyledTitle>{sysMessages[language][formStatus]}</StyledTitle>
					{formStatus === 'error' && (
						<>
							<p>
								{text[language].errorMsg1}
								<StyledEmail>sabien.prissette@gmail.com</StyledEmail>
								<br />
								{text[language].errorMsg2}
							</p>
							<ErrorMsgP>{formInfo.message}</ErrorMsgP>
						</>
					)}
					{formStatus !== 'sending' && dialog && (
						<StyledClose>
							<img alt={'close button'} src={circleX} />
						</StyledClose>
					)}
				</PostSend>
			)}
		</Wrapper>
	)
}

const MessageBox = styled.textarea`
	height: 200px;
	resize: none;
	opacity: 1;
	width: 100%;
	padding: 12px 18px;
	margin: 4px 0;
	margin-bottom: 12px;
	border-radius: 12px;
	border: 1px lightgrey solid;
`
const StyledForm = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: center;
	border-radius: 12px;
	padding: 25px;
	width: clamp(60vw, 700px, 60vw);
	background: white;
	@media (max-width: 1000px) {
		padding: 3%;
	}
	@media (max-width: 425px) {
		width: 300px;
	}
`
const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: 1px solid black;
	border-radius: 12px;
	width: fit-content;
	background: white;
	position: ${(props) => props.dialog};
	-webkit-box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
	box-shadow: 2px 5px 12px 1px rgba(0, 0, 0, 0.35);
`

const StyledClose = styled(DialogClose)`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: -17px;
	right: -17px;
	height: 34px;
	width: 34px;
	padding: 0px;
	background: white;
	border-radius: 50%;
	z-index: 2;
`
const PostSend = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	align-items: center;
	width: 60vw;
	min-height: 250px;
	padding: 25px;
	position: relative;
	/* background: white; */
`

const send = keyframes`
  0% {transform: translateX(0px); opacity: 100%}
  100% {transform: translateX(400px); opacity: 0%}

`

const Envelope = styled.img`
	animation: ${send} 1000ms cubic-bezier(0.9, -0.18, 0.9, 0.86) forwards;
	padding: 25px;
	height: auto;
	width: fit-content;
	color: black;
`

const InputWrap = styled.div`
	padding: 4px 0;
`
const StyledInput = styled.input`
	width: 100%;
	padding: 12px 18px;
	margin: 4px 0;
	border-radius: 12px;
	border: 1px lightgrey solid;
	::placeholder {
	}
`

const StyledSubmit = styled.input`
	padding: 12px;
	background-color: teal;
	border-radius: 12px;
	color: whitesmoke;
	transition: 0.4s ease-in-out;
	font-size: 1.2rem;
	margin-top: 12px;
	:hover {
		background-color: blue;
	}
`

const StyledTitle = styled.h3`
	font-size: 1.6rem;
	margin: 0 auto;
	width: fit-content;
	padding: 12px;
	padding-top: 4px;
`

const ErrorMsgP = styled.p`
	height: 200px;
	resize: none;
	overflow: auto;
	padding: 12px 18px;
	margin: 4px 0;
	border-radius: 12px;
	border: 1px lightgrey solid;
	text-align: start;
	white-space: pre-wrap;
	width: 100%;
	max-width: 100%;
`

const StyledEmail = styled.span`
	font-weight: 700;
`

export default Contact
